import { forwardRef } from "react";
const SvgText = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={8} height={8} viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M1 1H4M7 1H4M4 1V7" stroke="currentColor" strokeWidth={2} strokeLinecap="round" /></svg>;
const ForwardRef = forwardRef(SvgText);
export default ForwardRef;